import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import "./style.css";
import axios from "axios";
import { FeedPostMenu } from "../shared";
import EditPostPopup from "../../editPostPopup";

export default function PortfolioFeed() {
  const { user } = useSelector((state) => ({ ...state }));
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [category, setCategory] = useState("all");
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [selectedProject, setSelectedProject] = useState(null);
  const [editingPost, setEditingPost] = useState(null);

  const categories = [
    { id: "all", name: "Todos" },
    { id: "design", name: "Design" },
    { id: "development", name: "Desenvolvimento" },
    { id: "photography", name: "Fotografia" },
    { id: "illustration", name: "Ilustração" },
    { id: "motion", name: "Motion" },
    { id: "3d", name: "3D" },
    { id: "branding", name: "Branding" },
    { id: "ui_ux", name: "UI/UX" },
  ];

  const fetchPosts = async (pageNum = 1) => {
    try {
      let url = `${process.env.REACT_APP_BACKEND_URL}/feed/portfolio?page=${pageNum}&limit=16`;
      if (category !== "all") url += `&category=${category}`;

      const { data } = await axios.get(url, { headers: { Authorization: `Bearer ${user.token}` } });
      if (pageNum === 1) setPosts(data.posts || []);
      else setPosts((prev) => [...prev, ...(data.posts || [])]);
      setHasMore((data.pagination?.page || 1) < (data.pagination?.pages || 1));
      setLoading(false);
    } catch (error) {
      console.error("Error fetching portfolio:", error);
      setLoading(false);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { setPage(1); fetchPosts(1); }, [category]);

  const handleEditPost = (post) => {
    setSelectedProject(null);
    setEditingPost(post);
  };

  const handlePostUpdated = (updatedPost) => {
    setPosts((prev) => prev.map((p) => (p._id === updatedPost._id ? updatedPost : p)));
    setEditingPost(null);
  };

  const handlePostDeleted = (postId) => {
    setPosts((prev) => prev.filter((p) => p._id !== postId));
    setSelectedProject(null);
  };

  if (loading && posts.length === 0) {
    return <div className="portfolio_feed_loading"><div className="portfolio_loader"></div><span>Carregando projetos...</span></div>;
  }

  return (
    <div className="portfolio_feed">
      {categories.length > 0 && (
        <div className="simple_filter_bar">
          <div className="filter_buttons">
            {categories.map((filter) => (
              <button
                key={filter.id}
                className={`filter_btn ${category === filter.id ? "active" : ""}`}
                onClick={() => setCategory(filter.id)}
              >
                {filter.name}
              </button>
            ))}
          </div>
        </div>
      )}

      {posts.length === 0 ? (
        <div className="portfolio_feed_empty">
          <svg viewBox="0 0 24 24" fill="currentColor" width="64" height="64">
            <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-5-7l-3 3.72L9 13l-3 4h12l-4-5z"/>
          </svg>
          <h3>Nenhum projeto encontrado</h3>
          <p>Seja o primeiro a mostrar seu trabalho!</p>
        </div>
      ) : (
        <div className="portfolio_grid">
          {posts.map((post) => (
            <div key={post._id} className="portfolio_card" onClick={() => setSelectedProject(post)}>
              <div className="portfolio_thumbnail">
                <img src={post.portfolioData?.thumbnail || post.images?.[0]?.url || post.images?.[0] || "/images/default-portfolio.png"} alt="" />
                <div className="portfolio_overlay">
                  <h3>{post.portfolioData?.projectTitle || post.text}</h3>
                  <span>{categories.find(c => c.id === post.portfolioData?.category)?.name}</span>
                </div>
              </div>
              <div className="portfolio_card_footer">
                <Link to={`/profile/${post.user.username}`} className="portfolio_author" onClick={(e) => e.stopPropagation()}>
                  <img src={post.user.picture} alt="" />
                  <span>{post.user.first_name} {post.user.last_name}</span>
                </Link>
                <div className="portfolio_stats">
                  <span>
                    <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
                      <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
                    </svg>
                    {post.portfolioData?.likes || 0}
                  </span>
                  <span>
                    <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
                      <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/>
                    </svg>
                    {post.portfolioData?.views || 0}
                  </span>
                  <div onClick={(e) => e.stopPropagation()}>
                    <FeedPostMenu
                      post={post}
                      onEdit={handleEditPost}
                      onPostDeleted={handlePostDeleted}
                    />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {hasMore && (
        <div className="portfolio_load_more">
          <button onClick={() => { setPage(p => p + 1); fetchPosts(page + 1); }} disabled={loading}>
            {loading ? "Carregando..." : "Ver mais projetos"}
          </button>
        </div>
      )}

      {editingPost && (
        <EditPostPopup
          post={editingPost}
          user={user}
          setVisible={(visible) => !visible && setEditingPost(null)}
          onPostUpdated={handlePostUpdated}
        />
      )}

      {selectedProject && (
        <div className="portfolio_modal_overlay" onClick={() => setSelectedProject(null)}>
          <div className="portfolio_modal" onClick={(e) => e.stopPropagation()}>
            <button className="portfolio_modal_close" onClick={() => setSelectedProject(null)}>✕</button>
            <div className="portfolio_modal_gallery">
              {(selectedProject.portfolioData?.images || selectedProject.images || []).map((img, i) => (
                <img key={i} src={img.url || img} alt="" />
              ))}
            </div>
            <div className="portfolio_modal_info">
              <h2>{selectedProject.portfolioData?.projectTitle}</h2>
              <p className="portfolio_modal_desc">{selectedProject.portfolioData?.description || selectedProject.text}</p>
              {selectedProject.portfolioData?.tools?.length > 0 && (
                <div className="portfolio_tools">
                  <strong>Ferramentas:</strong>
                  <div className="portfolio_tools_list">
                    {selectedProject.portfolioData.tools.map((tool, i) => (
                      <span key={i}>{tool}</span>
                    ))}
                  </div>
                </div>
              )}
              <div className="portfolio_modal_footer">
                <Link to={`/profile/${selectedProject.user.username}`} className="portfolio_modal_author">
                  <img src={selectedProject.user.picture} alt="" />
                  <div>
                    <strong>{selectedProject.user.first_name} {selectedProject.user.last_name}</strong>
                    <span>@{selectedProject.user.username}</span>
                  </div>
                </Link>
                {selectedProject.portfolioData?.projectUrl && (
                  <a href={selectedProject.portfolioData.projectUrl} target="_blank" rel="noopener noreferrer" className="portfolio_view_btn">
                    Ver Projeto
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
